// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询推广文件详情 GET /promotion-files/detail */
export async function promotionFilesDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionFilesDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionFileDetailResp>('/promotion-files/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 校验推广文件密码 POST /promotion-files/verify-password */
export async function promotionFilesVerifyPasswordUsingPOST(
  body: API.PromotionFileVerifyPasswordReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionFileVerifyPasswordResp>(
    '/promotion-files/verify-password',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
